export const CLIENTS_COLLECTION = 'clients';
export const COMMERCIAL_OPERATIONS_COLLECTION = 'commercialOperations';
